export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14294.264f7d38.jpg";